import { render, staticRenderFns } from "./Onboarding.vue?vue&type=template&id=64de99bf&"
import script from "./Onboarding.vue?vue&type=script&lang=js&"
export * from "./Onboarding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64de99bf')) {
      api.createRecord('64de99bf', component.options)
    } else {
      api.reload('64de99bf', component.options)
    }
    module.hot.accept("./Onboarding.vue?vue&type=template&id=64de99bf&", function () {
      api.rerender('64de99bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/2.0/js/modules/Onboarding/Pages/Onboarding.vue"
export default component.exports